import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { LazyImage } from "@website/ui/lazy-image";
import AnimatedMapPinFloat from "@website/widget/filter/assets/animated-map-pin-float.svg";
import styles from "@website/widget/filter/index.module.scss";
import IranMapImage from "libs/widget/assets/images/iran_map.png";
interface Properties {
  onClick: () => void;
  label: string;
}
export function FilterMap(t0) {
  const $ = _c(10);
  const {
    onClick,
    label
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LazyImage alt="iran_map" className={styles["filter-map-image"]} src={IranMapImage.src} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <img alt="" className={styles["filter-map-pin"]} src={AnimatedMapPinFloat.src} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <span className={styles["filter-map-label"]}>{label}</span>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MaterialIcon className={styles["filter-map-chevron"]} name="chevron_left" variant="fill" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className={styles["filter-map-preview"]}>{t1}<div className={styles["filter-map-action"]}>{t2}{t3}{t4}</div></div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onClick || $[8] !== t5) {
    t6 = <button className={styles["filter-map-container"]} onClick={onClick} type="button">{t5}</button>;
    $[7] = onClick;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}